import i18next from 'i18next';
import { html } from 'lit';

export function handleExternalLink() {
  return html`<span id="hyperlink-sr-label" class="pds-link-sr-label"
    >${i18next.t('this-link-opens-in-a-new-tab')}</span
  >`;
}
